export default function googleAnalytics(router) {
  const measurementId = import.meta.env.VUE_APP_GOOGLE_ANALYTICS_ID;

  if (!measurementId) {
    return;
  }

  window.dataLayer = window.dataLayer || [];

  const gtag = (...args) => window.dataLayer.push(args);

  gtag('js', new Date());
  gtag('config', measurementId, {
    allow_ad_personalization_signals: false,
    allow_google_signals: false,
    anonymize_ip: true,
    send_page_view: false,
  });

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  document.head.appendChild(script);

  router.afterEach((to) => {
    const page = String(to.name || 'unknown');

    gtag('event', 'page_view', {
      page_location: `${window.location.origin}/${page}`,
    });

    if (['collection-search', 'search'].includes(to.name)) {
      gtag('event', 'view_search_results', {
        search_term: to.params.search,
      });
    }
  });
}
